import {
  validateEmail,
  validateMobile,
  validateName,
  validatePassword,
} from "GlobalUtils/Validate";
import { SCREEN } from "./Global";

export const USER_PASSWORD_RESET_ENDPOINT = "/api/user/reset-password/";
export const USER_CW_LOGIN_ENDPOINT = "/api/v2/login/";
export const USER_CW_LOGIN_CHECK_ENDPOINT = "/api/v1/login/check/";
export const USER_CW_SINGNUP_ENDPOINT = "/api/v3/signup/";
export const USER_CW_SOCIAL_SINGNUP_ENDPOINT = "/api/v1/login/social/";
export const USER_CW_CHECKLOGIN_ENDPOINT = "/api/isloggedin/web/";
export const SET_VEHICLE_DATA_ENDPOINT = "/api/advantage/customer/vehicle/";
export const USER_CW_LOGOUT_ENDPOINT = "/Users/Logout/";
export const URL_AFTER_LOGOUT = "/login/?returnUrl=/advantage/";

export const SCREEN_TYPE = {
  signup: "signup",
  login: "login",
  resetPassword: "reset-password",
};

export const TITLE = {
  [SCREEN.LOG_IN]: "Login to CarWale",
  [SCREEN.SIGN_UP]: "Sign Up to CarWale",
  [SCREEN.FORGOT_PASSWORD]: "Forgot Your Password?",
};

export const SUBTITLE = {
  [SCREEN.LOG_IN]: "This is necessary to personalise results for you",
  [SCREEN.SIGN_UP]: "This is necessary to personalise results for you",
  [SCREEN.FORGOT_PASSWORD]:
    "Please enter your email address, and we will send you a reset password link.",
};

export const MY_CAR_LISTINGS_URL = "/mycarwale/myinquiries/mysellinquiry.aspx";
export const MY_CARWALE_URL = "/mycarwale/";
export const EDIT_PROFILE_URL = "/users/profile/";
export const CHANGE_PASSWORD_URL = "/users/changepassword/";

export const validateMethod = {
  name: validateName,
  email: validateEmail,
  mobile: validateMobile,
  password: validatePassword,
};

export const SUCCESS_STATUS_CODES = [200, 401, 403];
